@if (!InProgress) {
<div class="container-fluid g-0">
  <form [formGroup]="RequestForm" (ngSubmit)="onSubmit()">
    <div class="row g-0 justify-content-between">
      <div class="sender-block">
        <div class="header d-flex justify-content-between">
          <h1>{{ "REQFORM.TH.FROMCARD" | translate }}</h1>
          <div class="logos d-flex">
            <img
              [src]="'REQFORM.IMG.VISALOGO' | imgsrc"
              onerror="this.alt = 'code:REQFORM.IMG.VISALOGO'"
            />
            <img
              [src]="'REQFORM.IMG.MASTERCARDLOGO' | imgsrc"
              onerror="this.alt = 'code:REQFORM.IMG.MASTERCARDLOGO'"
            />
          </div>
        </div>
        <div class="body">
          <iframe
            id="PSPSenderBlock"
            loading="eager"
            [src]="SRC.IFRAMESenderBlock"
          ></iframe>
          @for (field of SenderFormFields; track field) {
          <div class="form-field">
            <label>{{ field.Label | translate }}</label>
            @if(field.ID != 'SenderCountry') {

            <input
              id="{{ field.ID }}"
              formControlName="{{ field.Name }}"
              type="{{ field.Type }}"
              [ngClass]="{
                'err-input':
                  (RequestForm.controls[field.Name].invalid &&
                    RequestForm.controls[field.Name].touched) ||
                  (RequestForm.controls[field.Name].invalid && Submitted),
                'text-uppercase': [
                  'SenderCardHolderName',
                  'ReceiverCardHolderName'
                ].includes(field.ID)
              }"
              required="{{ field.Required }}"
              class="shadow-none form-control"
              placeholder="{{ field.Placeholder | translate }}"
              value="{{ field.Value }}"
              maxlength="{{ field.MaxLength }}"
              minlength="{{ field.MinLength }}"
              [attr.autocomplete]="field.AutoComplete"
              (keypress)="FormControlKeyPress($event)"
              (focusout)="AlphaFocusOut($event, field.FormControl)"
              (paste)="FormControlPaste($event)"
            />
            }@else {
            <input
              id="{{ field.ID }}"
              formControlName="SenderCountryName"
              type="{{ field.Type }}"
              [ngClass]="{
                'err-input':
                  (RequestForm.controls[field.Name].invalid &&
                    RequestForm.controls[field.Name].touched) ||
                  (RequestForm.controls[field.Name].invalid && Submitted),
                'text-uppercase': [
                  'SenderCardHolderName',
                  'ReceiverCardHolderName'
                ].includes(field.ID)
              }"
              required="{{ field.Required }}"
              class="shadow-none form-control dropdown-toggle"
              placeholder="{{ field.Placeholder | translate }}"
              value="{{ field.Value }}"
              maxlength="{{ field.MaxLength }}"
              (keypress)="FormControlKeyPress($event)"
              (focusout)="AlphaFocusOut($event, field.FormControl)"
              (paste)="FormControlPaste($event)"
              (input)="FilterSelectCountry($event)"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            />

            <ul
              class="dropdown-menu"
              role="menu"
              [class.d-none]="FilteredCountries?.length == 0"
            >
              @for(country of FilteredCountries;track $index){
              <li role="menuitem" [value]="country.Code">
                <a class="dropdown-item" (click)="SelectCountry(country)">
                  {{ country.Name }}
                </a>
              </li>
              }
            </ul>
            } @if ( (RequestForm.controls[field.Name].invalid &&
            RequestForm.controls[field.Name].touched) ||
            (RequestForm.controls[field.Name].invalid && Submitted) ) {
            <h6 class="err-msg">
              {{
                field.mapError(RequestForm.controls[field.Name].errors)
                  | translate
              }}
            </h6>
            }
          </div>
          }
        </div>
      </div>
      <div class="receiver-block">
        <div class="header d-flex justify-content-between">
          <h1>{{ "REQFORM.TH.TOCARD" | translate }}</h1>
          <div class="logos d-flex">
            <img
              [src]="'REQFORM.IMG.VISALOGO' | imgsrc"
              onerror="this.alt = 'code:REQFORM.IMG.VISALOGO'"
            />
            <img
              [src]="'REQFORM.IMG.MASTERCARDLOGO' | imgsrc"
              onerror="this.alt = 'code:REQFORM.IMG.MASTERCARDLOGO'"
            />
          </div>
        </div>
        <div class="body">
          <iframe
            id="PSPReceiverBlock"
            loading="eager"
            [src]="SRC.IFRAMEReceiverBlockCardNr"
          ></iframe>
          @for (field of ReceiverFormFields; track field) {
          <div class="form-field">
            <label>{{ field.Label | translate }}</label>
            <input
              id="{{ field.ID }}"
              formControlName="{{ field.Name }}"
              type="{{ field.Type }}"
              class="shadow-none form-control"
              [ngClass]="{
                'err-input':
                  (RequestForm.controls[field.Name].invalid &&
                    RequestForm.controls[field.Name].touched) ||
                  (RequestForm.controls[field.Name].invalid && Submitted),
                'text-uppercase': [
                  'SenderCardHolderName',
                  'ReceiverCardHolderName'
                ].includes(field.ID)
              }"
              required="{{ field.Required }}"
              placeholder="{{ field.Placeholder | translate }}"
              value="{{ field.Value }}"
              maxlength="{{ field.MaxLength }}"
              [attr.autocomplete]="field.AutoComplete"
              (keypress)="FormControlKeyPress($event)"
              (focusout)="AlphaFocusOut($event, field.FormControl)"
              (paste)="FormControlPaste($event)"
            />
            @if ( (RequestForm.controls[field.Name].invalid &&
            RequestForm.controls[field.Name].touched) ||
            (RequestForm.controls[field.Name].invalid && Submitted) ) {
            <h6 class="err-msg">
              {{
                field.mapError(RequestForm.controls[field.Name].errors)
                  | translate
              }}
            </h6>
            }
          </div>
          } @for (field of AmountFormFields; track field) {
          <div class="app-receiver-amount form-field d-flex">
            @if (field.HasFormControlValidation) {
            <div class="col">
              <label>{{ field.Label | translate }}</label>
              <input
                id="{{ field.ID }}"
                formControlName="{{ field.Name }}"
                type="{{ field.Type }}"
                class="shadow-none form-control"
                [ngClass]="{
                  'err-input':
                    (RequestForm.controls[field.Name].invalid &&
                      RequestForm.controls[field.Name].touched) ||
                    (RequestForm.controls[field.Name].invalid && Submitted)
                }"
                required="{{ field.Required }}"
                placeholder="{{ field.Placeholder | translate }}"
                value="{{ field.Value }}"
                maxlength="{{ field.MaxLength }}"
                [attr.autocomplete]="field.AutoComplete"
                (keypress)="AmountKeyPress($event)"
                (focusin)="AmountFocusIn($event)"
                (focusout)="AmountFocusOut()"
                (paste)="$event.preventDefault()"
              />
              @if ( (RequestForm.controls[field.Name].invalid &&
              RequestForm.controls[field.Name].touched) ||
              (RequestForm.controls[field.Name].invalid && Submitted) ) {
              <h6 class="err-msg">
                {{
                  field.mapError(RequestForm.controls[field.Name].errors)
                    | translate
                }}
              </h6>
              }
            </div>
            @if (CurrenciesList?.length > 1) {
            <div class="dropdown">
              <button
                class="btn btn-dropdown dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {{ CurrencyNameControl.value }}
              </button>
              <ul class="dropdown-menu">
                @for (currency of CurrenciesList; track currency) {
                <li (click)="ChangeCurrency(currency.Num)">
                  <a class="dropdown-item">{{ currency.Code }}</a>
                </li>
                }
              </ul>
            </div>
            } @else {
            <div class="dropdown">
              <button class="btn btn-dropdown" type="button">
                {{ CurrencyNameControl.value }}
              </button>
            </div>
            } } @else {
            <div class="col">
              <label>{{ field.Label | translate }}</label>
              <input
                id="{{ field.ID }}"
                formControlName="{{ field.Name }}"
                type="{{ field.Type }}"
                class="shadow-none form-control"
                required="{{ field.Required }}"
                placeholder="{{ field.Placeholder | translate }}"
                [attr.autocomplete]="field.AutoComplete"
                [readonly]="field.Readonly"
                (onpaste)="$event.preventDefault()"
              />
              @if (field.ID === 'Fee') {
              <h6 class="err-msg">
                {{ GetServerError(field.ID)?.error | translate }}
              </h6>
              }
            </div>
            <div class="dropdown">
              <button class="btn btn-dropdown" type="button">
                {{ CurrencyNameControl.value }}
              </button>
            </div>
            }
          </div>
          }
        </div>
      </div>
    </div>
    <div class="row g-0 justify-content-center">
      <div class="form-confirmation col-auto">
        <div class="terms-agreement-block row g-0">
          <div class="switch-block col-auto">
            <label class="switch">
              <input type="checkbox" formControlName="RequestConfirmation" />
              <span class="slider"></span>
            </label>
          </div>
          <div class="terms col-auto">
            <label>
              <a
                href="{{ 'REQFORM.HREF.TERMS_PDF' | translate }}"
                download
                [innerHTML]="'REQFORM.LBL.TERMS' | translate"
              >
              </a
            ></label>
          </div>
        </div>
        @if ( RequestForm.controls['RequestConfirmation'].invalid && Submitted )
        {
        <h6 class="err-msg">
          {{ "REQFORM.ERR.REQ.REQUESTCONFIRMATION" | translate }}
        </h6>
        }
        <h6 class="err-msg">
          {{ GetServerError("Recaptcha")?.error | translate }}
        </h6>
        <button type="submit" class="btn btn-p2p">
          {{ "REQFORM.BTN.TRANSFER" | translate }}
        </button>
      </div>
    </div>
  </form>
  <iframe
    id="PSPCallBackPageTO"
    loading="eager"
    [src]="SRC.IFRAMECallBackPageTO"
    style="width: 0; height: 0; border: 0"
  ></iframe>
</div>
}
